<template lang="pug">
  .height-100
    h3.title Gestión de mis vacaciones
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .mensaje-informacion(v-if="mostrarMensajeDeSolicitud", key="mensaje_no_dias")
        .message.is-info
          .message-body
            span.icon.close(
              @click="mostrarMensajeDeSolicitud = false"
            )
              i.fa.fa-close
            span No puede realizar solicitudes de vacaciones porque cuentas con&nbsp;
            strong {{ empleado.diasDisponibles}}
            span &nbsp;días disponibles.
            br
            span Debes acumular al menos 1 día para hacerlo.

      .box.nueva-solicitud(v-if="mostrarSolicitud", key="nueva_solicitud")
        nueva-solicitud-vacaciones(
          @close="mostrarSolicitud = false"
          @successNew="recargarListaSolicitudes"
        )
      .box.lista-solicitud(v-if="mostrarListaSolicitudes", key="lista_solicitud")
        lista-solicitud-vacaciones(
          ref="listasolicitudes"
          @close="mostrarListaSolicitudes = false"
        )
      .box.lista-solicitud(v-if="mostrarListaLibrosVacaciones", key="lista_libros_vacaciones")
        lista-libros-vacaciones(
          @close="mostrarListaLibrosVacaciones = false"
        )
      .box.lista-solicitud(v-if="mostrarListaVacaciones", key="lista_vacaciones")
        lista-vacaciones(
          @close="mostrarListaVacaciones = false"
        )

</template>

<script>
import { apiGet } from '../util/general'
import SolicitudVacacionesComponent from './Component_Solicitud_Vacaciones'
import ListaSolicitudVacacionesComponent from './Lista_Solicitud_Vacaciones_Component'
import ListaVacacionesComponent from './Component_Lista_Vacaciones'
import ListaLibrosVacacionesComponent from './Component_Lista_Libros_Vacaciones'
export default {
  name: 'vacaciones',
  components: {
    'nueva-solicitud-vacaciones': SolicitudVacacionesComponent,
    'lista-solicitud-vacaciones': ListaSolicitudVacacionesComponent,
    'lista-vacaciones': ListaVacacionesComponent,
    'lista-libros-vacaciones': ListaLibrosVacacionesComponent
  },
  data () {
    return {
      mostrarSolicitud: true,
      mostrarListaSolicitudes: true,
      mostrarListaVacaciones: true,
      mostrarListaLibrosVacaciones: true,
      mostrarMensajeDeSolicitud: false,
      empleado: {}
    }
  },
  watch : {
  },
  created () {
    this.fetchPrivateInformation()
  },
  methods: {
    fetchPrivateInformation () {
      var vm = this
      var obj = {
      }

      apiGet(vm, '/vacaciones/empleado/private', obj, function (data) {
        vm.empleado = data.data

        // Vemos si mostramos o no
        if (vm.empleado.diasDisponibles < 1) {
          vm.mostrarSolicitud = false
          vm.mostrarMensajeDeSolicitud = true
        }
      }, function (error) {
        alert('error: ' + error.message)
      })
    },
    recargarListaSolicitudes () {
      this.mostrarListaSolicitudes = true
      this.$refs.listasolicitudes.fetch()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%

  .mensaje-informacion
    margin-bottom 10px
    .close
      float right
      cursor pointer
      i
        font-size 16px
  .nueva-solicitud
    position relative
  .lista-solicitud
    position relative
</style>



// WEBPACK FOOTER //
// Vacaciones_View.vue?18a7afc2